<template>
  <div class="">
    <div class="mt-12 border-t-4 pt-10 border-grey-lighter flex items-center">
      <div class="font-thin text-grey-darker text-2xl uppercase">Beneficiaries</div>
      <a href="#" class="text-gray-600 text-sm ml-8 hover:underline" @click.prevent="add">Add a beneficiary</a>
    </div>

    <template v-if="beneficiaries != null && beneficiaries.length > 0">
      <template v-for="(beneficiary, index) in beneficiaries">
        <div class="flex items-center mt-2">
          <div class="w-1/3">
            <input type="text" 
              v-model="beneficiary.name"
              v-on:change="updateValue(index, 'name', $event.target.value)"
              class="input-standard"
              placeholder="Name" />
          </div>

          <a href="#" 
            class="text-gray-600 hover:text-red-500 text-xs uppercase hover:underline ml-4" 
            @click.prevent="deleteBeneficiary(index)">Delete</a>
        </div>
      </template>
    </template>

    <template v-else>
      <div class="text-gray-700 text-base mt-4">
        You have not added any beneficiaries.
      </div>
    </template>
  </div>
</template>

<script>
  import InputText        from '@/shared/components/form/InputText'
  import { EventBus }     from '@/shared/event-bus';

  export default {

    components: {
      InputText,
    },

    props : {
      trustId : {
        type    : Number,
        required: true
      }
    },

    data() {
      return {
        beneficiaries : []
      }
    },

    created() {
      this.getbeneficiaries()
    },

    methods : {

      getbeneficiaries() {
        this.apiGet({
          clientId: this.$route.params.clientId,
          trustId : this.trustId,          
        }, 'trust/list-beneficiaries', (beneficiaries) => {
          this.beneficiaries = beneficiaries
        })
      },

      add() {
        this.showLoader("Adding a beneficiary...")
        this.apiPost({
          clientId   : this.$route.params.clientId,
          applicantId: this.$route.params.applicantId,
          trustId    : this.trustId          
        }, 'trust/create-beneficiary', (beneficiary) => {
          this.hideLoader()
          this.beneficiaries.push(beneficiary)          
        })
      },

      deleteBeneficiary(index) {
        this.$modal.show('confirm-modal', {
          // width : 600,
          title  : "Please confirm your action",
          message: "Are you sure you want to delete this?",
          buttons:[{
            label          : 'Yes',
            color          : 'red',
            loadingViaLocal: true, // a bit of HACK, we want to show loading image when button is clicked, but hard to pass loading prop to a modal
            action         : () => {
              this.apiDelete({
                clientId     : this.$route.params.clientId,
                applicantId  : this.$route.params.applicantId,
                beneficiaryId: this.beneficiaries[index].id
              }, 'trust/delete-beneficiary', () => {
                this.$modal.hide('confirm-modal')
                this.beneficiaries.splice(index, 1)
                EventBus.$emit('notification-event', {
                  'type'   : 'success',
                  'message': "Beneficiary deleted successfully"
                });
              })
            }
          }, {
            label : 'No',
            color : 'gray',
            action: () => {
              this.$modal.hide('confirm-modal')
            }
          }]
        })
      },

      // a method that will receive the value and update
      updateValue(index, key, value) {
        if(this.beneficiaries[index].key != value) {
          EventBus.$emit('set-autosave', true)
          this.apiPost({
            clientId     : this.$route.params.clientId,
            applicantId  : this.$route.params.applicantId,
            beneficiaryId: this.beneficiaries[index].id,
            key,
            value            
          }, 'trust/save-beneficiary', () => {
            EventBus.$emit('set-autosave', false)
          })
        }
      },
    }

  }
</script>